import React, { useEffect, useState } from "react";
import RELoader from "../RELoader";
import "./PageLoader.css";

const PageLoader = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  if (!isLoading) return null;

  return (
    <div className="re-page-loader" id="pageLoader">
      <RELoader minHeight="100vh" />
    </div>
  );
};

export default PageLoader;
